import { useTranslation } from 'react-i18next';
import { DefaultCard } from '../../../../DefaultCard';

export const Disclaimer = () => {
  const [t] = useTranslation('vulnerability');
  return (
    <DefaultCard header={t('disclaimer.Disclaimer')} id='disclaimer'>
      {t('disclaimer.text')}
    </DefaultCard>
  );
};
